module.exports = __webpack_public_path__ + "assets/img/typeIcon-5-yellow.af5a8008.svg";